import { EntityTable } from '@/features/admin/EntityTable';
import { Badge } from '@/components/ui/Badge';

const ROLE_OPTIONS = [
  { value: 'ADMIN', label: 'Administrador' },
  { value: 'SUPERVISOR', label: 'Supervisor CME' },
  { value: 'NURSE_RT', label: 'Enfermeiro RT (libera lote)' },
  { value: 'NURSE', label: 'Enfermeiro' },
  { value: 'TECHNICIAN', label: 'Técnico CME' },
  { value: 'VIEWER', label: 'Somente leitura' },
];

const ROLE_TONE: Record<string, any> = {
  ADMIN: 'danger', SUPERVISOR: 'warning', NURSE_RT: 'brand',
  NURSE: 'info', TECHNICIAN: 'neutral', VIEWER: 'neutral',
};

export function UsuariosPage() {
  return (
    <EntityTable
      title="Usuários"
      subtitle="Operadores, supervisores, RT enfermeiro e administradores"
      endpoint="/v1/users"
      queryKey="users"
      deleteRoles={['ADMIN']}
      itemLabel={(r: any) => r.full_name || r.email}
      columns={[
        { key: 'full_name', label: 'Nome' },
        { key: 'email', label: 'E-mail', className: 'text-xs text-neutral-500' },
        {
          key: 'role', label: 'Papel',
          render: (r: any) => <Badge tone={ROLE_TONE[r.role] ?? 'neutral'}>{ROLE_OPTIONS.find(o => o.value === r.role)?.label ?? r.role}</Badge>,
        },
        { key: 'matricula', label: 'Matrícula', className: 'font-mono text-xs' },
        {
          key: 'rfid_hex', label: 'RFID',
          render: (r: any) => r.rfid_hex ? <Badge tone="success">vinculado</Badge> : <span className="text-xs text-neutral-400">—</span>,
        },
      ]}
      fields={[
        { name: 'full_name', label: 'Nome completo', type: 'text', required: true },
        { name: 'email', label: 'E-mail', type: 'email', required: true },
        { name: 'password', label: 'Senha inicial', type: 'text', hideOnEdit: true, required: true, hint: 'mín. 8 caracteres' },
        { name: 'role', label: 'Papel', type: 'select', required: true, options: ROLE_OPTIONS },
        { name: 'matricula', label: 'Matrícula', type: 'text' },
        { name: 'crm_coren', label: 'CRM / COREN', type: 'text', hint: 'obrigatório para NURSE_RT' },
        { name: 'rfid_hex', label: 'RFID (hex)', type: 'text', hint: 'opcional, identifica crachá' },
        { name: 'avatar_r2_key', label: 'Foto do usuário', type: 'image', uploadEntity: 'user', uploadKind: 'PHOTO', hint: 'PNG/JPG/WebP até 5 MB' },
        { name: 'active', label: 'Ativo', type: 'checkbox', defaultValue: true, hideOnCreate: true },
      ]}
    />
  );
}
